import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Main from './pages/Main';
import LectureMain from './pages/LectureMain';
import Order from './pages/Order';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFail from './pages/PaymentFail';
import Status from './pages/Status';
import See from './pages/See';
import PurchaseCanvas from './pages/PurchaseCanvas';
import LectureDemo from './pages/LectureDemo';
import Offline from './pages/Offline';
import AdminCoupon from './pages/AdminCoupon';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<App />} />
            <Route path="/lecture-demo" element={<LectureDemo />} />
            <Route path="/main" element={<Main />} />
            <Route path="/lecture-main" element={<LectureMain />} />
            <Route path="/offline" element={<Offline />} />
            <Route path="/order" element={<Order />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-fail" element={<PaymentFail />} />
            <Route path="/status" element={<Status />} />
            <Route path="/see" element={<See />} />
            <Route path="/purchase-canvas" element={<PurchaseCanvas />} />
            <Route path="/admin-coupon" element={<AdminCoupon />} />
        </Routes>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
